module.exports = __webpack_public_path__ + "img/20.fe979c89.jpg";